module.exports = __webpack_public_path__ + "img/diamong_text.8d340dc5.png";